module.exports = __webpack_public_path__ + "static/media/Avenir-Book.ecb0c2ae.otf";